<template>
    <div class="invoiceTable">
        <slot-table v-if="tableData" :data="tableData" :columns="columnData">
          <template slot="date" slot-scope="props">
            <span>{{ props.item.date.value | formatDate }}</span>
          </template>

          <template slot="amount" slot-scope="props">
            <span><span v-html="currencySymbol(currency)" />{{ delimitNumbers(props.item.amount) }}</span>
          </template>
          <template slot="adjustmentsActions" slot-scope="props">
                <span v-if="isAdmin">
                  <button-cta data-modalType="editAdjustment" :data-modalId="props.item.id" :onClick="edit" class="btn btn-warning btn-xs">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </button-cta>
                  <button-cta data-modalType="deleteAdjustment" :data-modalId="props.item.id" :onClick="edit" class="btn btn-danger btn-xs">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button-cta>
                </span>
          </template>

        </slot-table>
    </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import {invoiceMixin} from '@/mixins/invoiceMixin'

export default {
  name: 'InvoicesChargesTable',
  components: {
    SlotTable,
    ButtonCta
  },
  mixins: [invoiceMixin],
  props: {
    tableData: Array,
    columnData: Object,
    edit: Function,
    isAdmin: Boolean,
    currency: String
  },
  data: () => ({}),
  methods: {}
}
</script>

<style lang="scss">
    @import "invoice-breakdown-table";
</style>



// WEBPACK FOOTER //
// src/components/InvoiceBreakdownTable/invoice-breakdown-table.vue